import ApiBaseService from "services/ApiBaseService.js";

class DoctorFormService {
  static addAssessmentForm([hospitalId, patientId, data]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms`,
      "POST",
      data
    );
  }

  static getAssessmentForms([hospitalId, patientId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms`,
      "GET"
    );
  }

  static getAssessmentForm(hospitalId, patientId, formId) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}`,
      "GET"
    );
  }

  static saveAssessmentForm(hospitalId, patientId, formId, data) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}`,
      "PUT",
      data
    );
  }

  static submitAssessmentForm(hospitalId, patientId, formId) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}`,
      "POST",
      {}
    );
  }

  static deleteAssessmentForm([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}`,
      "DELETE"
    );
  }

  static revokeAssessmentFormSubmission([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/revoke`,
      "POST"
    );
  }

  static getAssessmentAnalysis([hospitalId, patientId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/analysis`,
      "GET"
    );
  }

  static getStimFormReportData([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/stim-report-data`,
      "GET"
    );
  }

  static getLevelProgressSectionNames([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/level-progress-section-names`,
      "GET"
    );
  }

  static getAssessmentSectionLevelProgress([
    hospitalId,
    patientId,
    formId,
    sectionName,
  ]) {
    const q = encodeURIComponent(sectionName);
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/level-progress?sectionName=${q}`,
      "GET"
    );
  }
}

export default DoctorFormService;
